export default __webpack_public_path__ + "static/media/Abby.98006368.png";